var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepperActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7348 4.63397C18.4494 1.20581 11.7835 0.920135 8.73624 1.20581C7.87919 1.68193 5.93655 2.80557 5.02237 3.4912C3.87965 4.34824 1.59425 8.63344 1.02289 10.6332C0.451532 12.633 1.30857 14.9184 2.16561 16.3468C3.02265 17.7752 7.02216 21.7747 8.73624 22.9174C10.4503 24.0601 15.3069 24.6315 16.7353 24.9172C18.1637 25.2029 20.7348 23.2031 22.4489 21.2033C23.8201 19.6035 24.1629 15.2041 24.1629 13.2043C23.9725 11.7759 23.0202 8.06213 20.7348 4.63397Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.14272
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3075 13.1203C12.8504 12.6632 8.16525 15.5964 6.45117 17.977C7.59389 19.6911 10.7364 21.4051 11.8791 21.6907C13.0218 21.9764 13.8788 13.6916 13.3075 13.1203Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.857039
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5927 13.1205C13.2341 12.5826 17.3713 16.9793 19.0204 19.4054C18.6885 21.111 11.0071 21.9107 12.1643 21.6909C12.45 21.6367 14.164 13.9775 13.5927 13.1205Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.857039
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7358 12.5494C13.1915 13.0079 8.73658 14.8348 6.45106 17.9774C4.73674 16.5489 3.61816 12.9346 3.33597 11.791C3.05378 10.6474 12.1662 11.9763 12.7358 12.5494Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.857039
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.593 12.5492C13.0466 12.8946 17.3504 15.8534 18.8779 19.4264C20.6127 19.5247 22.7349 13.4064 21.5921 13.4064C19.7629 13.4064 14.2761 12.1175 13.593 12.5492Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.857039
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7353 12.2638C12.1982 12.6235 9.15002 7.9814 7.93052 5.31336C8.54337 3.68744 11.8446 3.46624 13.021 3.40774C14.1974 3.34925 13.4067 11.8142 12.7353 12.2638Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.857039
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1779 12.1587C12.7218 12.6167 17.9693 8.8816 20.0579 6.82163C20.0633 5.08405 12.3473 3.03379 13.4399 3.47394C13.7096 3.5826 13.9047 11.4288 13.1779 12.1587Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.857039
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4499 12.2635C13.0466 12.5121 9.51131 8.64803 7.87907 5.12172C6.39964 6.38379 3.30846 8.26412 3.30846 11.4066C3.30846 11.722 9.02189 10.8351 12.4499 12.2635Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.857039
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5932 11.9781C14.8577 11.5666 18.1642 7.69284 20.1638 7.12156C21.8847 7.36178 22.9178 13.1605 21.7399 13.1605C20.1638 13.1604 12.8249 12.2281 13.5932 11.9781Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.857039
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1704 11.7848C14.1704 11.3278 12.4563 11.0563 12.4563 12.3562C12.3414 13.4991 13.6561 13.4991 13.8847 13.4991H13.8847C14.456 13.4991 14.1704 12.3562 14.1704 11.7848Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.857039
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperActive);
export default __webpack_public_path__ + "static/media/stepperActive.bba6b8692b3f28c01376286ffac70118.svg";
export { ForwardRef as ReactComponent };